/**
 * Copy för autopilot-presentationen.
 *
 * Beskriver föreningens år så som det är tänkt att skötas. Scener vars funktion ligger
 * senare i ordningen bär en diskret `vision`-markering i vyn.
 *
 * Siffrorna beskriver vad en vy visar — aldrig hur många som använder den. Uppgifter om
 * kunder, spridning eller resultat finns inte och hittas inte på.
 */

export const ÅRSHJUL = [
    { id: 'jan', etikett: 'Januari', under: 'AGD · moms' },
    { id: 'feb', etikett: 'Februari', under: 'AGD' },
    { id: 'mar', etikett: 'Mars', under: 'AGD · moms' },
    { id: 'apr', etikett: 'April', under: 'AGD' },
    { id: 'maj', etikett: 'Maj', under: 'AGD · moms' },
    { id: 'jun', etikett: 'Juni', under: 'AGD' },
    { id: 'jul', etikett: 'Juli', under: 'AGD' },
    { id: 'aug', etikett: 'Augusti', under: 'AGD · moms' },
    { id: 'sep', etikett: 'September', under: 'AGD' },
    { id: 'okt', etikett: 'Oktober', under: 'AGD · moms' },
    { id: 'nov', etikett: 'November', under: 'AGD' },
    { id: 'dec', etikett: 'December', under: 'Bokslut' }
];

export const BOKSLUTSSTEG = [
    { id: 'affar', etikett: 'Affärshändelser', under: 'Genomgångna' },
    { id: 'period', etikett: 'Periodisering', under: 'Fördelad' },
    { id: 'rr', etikett: 'Resultaträkning', under: 'Beräknad' },
    { id: 'br', etikett: 'Balansräkning', under: 'Avstämd' },
    { id: 'vinst', etikett: 'Vinstdisposition', under: 'Föreslagen' },
    { id: 'ar', etikett: 'Årsredovisning', under: 'Genererad' }
];

export const VYER = [
    {
        nyckel: 'styrelsen',
        etikett: 'Styrelsens vy',
        rubrik: 'Vad styrelsen ser',
        rader: [
            ['Räkenskapsår', '2026-01-01 – 2026-12-31'],
            ['Bokförda verifikationer', '1 284'],
            ['Årets resultat', '412 800 kr'],
            ['Kvar att göra', 'Signera årsredovisningen']
        ]
    },
    {
        nyckel: 'medlem',
        etikett: 'Medlemmens vy',
        rubrik: 'Vad medlemmen ser',
        rader: [
            ['Räkenskapsår', '2026-01-01 – 2026-12-31'],
            ['Årsredovisning', 'Publicerad 12 mars'],
            ['Årets resultat', '412 800 kr'],
            ['Min månadsavgift', '4 850 kr']
        ]
    }
];

export const RISKSIGNALER = [
    { id: 'r1', text: 'Styrelseuppdrag i bolag under konkurs', flaggad: true },
    { id: 'r2', text: 'Näringsförbud', flaggad: true },
    { id: 'r3', text: 'Betalningsanmärkningar', flaggad: false },
    { id: 'r4', text: 'Skatteskulder hos Kronofogden', flaggad: false }
];
